import { Card, CardTitle, Col } from 'reactstrap';
import { ItemDashboard } from './ItemDasboard';
import { User, TrendingUp } from 'react-feather';

const StatsComponent = ({ data }) => {
  return (
    <Card body>
      <CardTitle
        color="#6D6B7B"
        style={{
          fontWeight: '600',
          fontSize: 20
        }}
      >
        Estadísticas
      </CardTitle>

      <Col md="12" className={'d-flex gap-3'}>
        <ItemDashboard
          title="Usuarios"
          amount={data.totalUsers}
          style="decimal"
          icon={<User size={20} color="#46d0e8" />}
          bgicon="#e8fafd"
        />
        <ItemDashboard
          title="Planes realizados"
          amount={data.totalRoadsFinished}
          style="decimal"
          icon={<TrendingUp size={20} color="#7e73f1" />}
          bgicon="#eeedfd"
        />
      </Col>
    </Card>
  );
};

export default StatsComponent;
